export const onboardingSteps = {
  ONBOARDING_START: 'onboarding-start',
  DEVICES_PENDING_ONBOARDING_START: 'devices-pending-onboarding-start',
  DASHBOARD_ONBOARDING_START: 'dashboard-onboarding-start',
  DASHBOARD_ONBOARDING_PENDINGS: 'dashboard-onboarding-pendings',
  DEVICES_PENDING_ONBOARDING: 'devices-pending-onboarding',
  DEVICES_ACCEPTED_ONBOARDING: 'devices-accepted-onboarding',
  DEVICES_PENDING_ACCEPTING_ONBOARDING: 'devices-pending-accepting-onboarding',
  DEVICES_ACCEPTED_ONBOARDING_NOTIFICATION: 'devices-accepted-onboarding-notification',
  UPLOAD_PREPARED_ARTIFACT_TIP: 'upload-prepared-artifact-tip',
  APPLICATION_UPDATE_REMINDER_TIP: 'application-update-reminder-tip',
  ARTIFACT_INCLUDED_ONBOARDING: 'artifact-included-onboarding',
  ARTIFACT_INCLUDED_DEPLOY_ONBOARDING: 'artifact-included-deploy-onboarding',
  SCHEDULING_ARTIFACT_SELECTION: 'scheduling-artifact-selection',
  SCHEDULING_ALL_DEVICES_SELECTION: 'scheduling-all-devices-selection',
  SCHEDULING_GROUP_SELECTION: 'scheduling-group-selection',
  SCHEDULING_RELEASE_TO_DEVICES: 'scheduling-release-to-devices',
  DEPLOYMENTS_INPROGRESS: 'deployments-inprogress',
  DEPLOYMENTS_PAST: 'deployments-past',
  DEPLOYMENTS_PAST_COMPLETED: 'deployments-past-completed',
  DEPLOYMENTS_PAST_COMPLETED_NOTIFICATION: 'deployments-past-completed-notification',
  DEPLOYMENTS_PAST_COMPLETED_FAILURE: 'deployments-past-completed-failure',
  ARTIFACT_CREATION_DIALOG: 'artifact-creation-dialog',
  UPLOAD_NEW_ARTIFACT_TIP: 'upload-new-artifact-tip',
  UPLOAD_NEW_ARTIFACT_DIALOG_UPLOAD: 'upload-new-artifact-dialog-upload',
  UPLOAD_NEW_ARTIFACT_DIALOG_DESTINATION: 'upload-new-artifact-dialog-destination',
  UPLOAD_NEW_ARTIFACT_DIALOG_DEVICE_TYPE: 'upload-new-artifact-dialog-device-type',
  UPLOAD_NEW_ARTIFACT_DIALOG_RELEASE_NAME: 'upload-new-artifact-dialog-release-name',
  UPLOAD_NEW_ARTIFACT_DIALOG_CLICK: 'upload-new-artifact-dialog-click',
  ARTIFACT_MODIFIED_ONBOARDING: 'artifact-modified-onboarding',
  ONBOARDING_FINISHED: 'onboarding-finished',
  ONBOARDING_FINISHED_NOTIFICATION: 'onboarding-finished-notification',
  ONBOARDING_CANCELED: 'onboarding-canceled'
};
export const SET_DEMO_ARTIFACT_PORT = 'SET_DEMO_ARTIFACT_PORT';
export const SET_ONBOARDING_COMPLETE = 'SET_ONBOARDING_COMPLETE';
export const SET_ONBOARDING_PROGRESS = 'SET_ONBOARDING_PROGRESS';
export const SET_ONBOARDING_DEVICE_TYPE = 'SET_ONBOARDING_DEVICE_TYPE';
export const SET_ONBOARDING_APPROACH = 'SET_ONBOARDING_APPROACH';
export const SET_ONBOARDING_ARTIFACT_INCLUDED = 'SET_ONBOARDING_ARTIFACT_INCLUDED';
export const SET_SHOW_CREATE_ARTIFACT = 'SET_SHOW_CREATE_ARTIFACT';
export const SET_SHOW_ONBOARDING_HELP = 'SET_SHOW_ONBOARDING_HELP';
export const SET_SHOW_ONBOARDING_HELP_DIALOG = 'SET_SHOW_ONBOARDING_HELP_DIALOG';
